// import useTranslation from "next-translate/useTranslation";
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

interface Props {
  data: any;
}

export default function CardPostHeader({ data }: Props) {
  const [title, setTitle] = useState<string>('');
  const [postImage, setPostImage] = useState<string>('');
  // const { t } = useTranslation("common");

  useEffect(() => {
    setTitle(data[0]?.attributes?.title);
    setPostImage(data[0]?.attributes?.mainImage?.data?.attributes.url);
  }, [data]);

  return (
    <Flex
      basis="0"
      grow="1"
      as={Link}
      href={`/blog/${data[0].attributes.url}`}
      height="100%"
      direction="column"
      justifyContent="flex-end"
      alignItems="flex-start"
      padding="0 !important"
      gap="24px"
      _hover={{ textDecoration: 'none', boxShadow: 'lg' }}
      borderRadius="8px"
      bg={`linear-gradient(180deg, rgba(45, 55, 72, 0) 0%, #2D3748 88.02%), center / cover no-repeat url(${postImage})`}
    >
      {/* <HStack alignItems="center" gap="8px">
          {category.length > 0 &&
            category.map((item, index) => (
              <Link
                key={index}
                href={`/categoria/${item.slug}`}
                backgroundColor={item.bgColor}
                borderRadius="2px"
                px="4px"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                color={item.color}
                textDecor="none"
                fontWeight={700}
                fontSize="12px"
                lineHeight="16px"
              >
                {item.title}
              </Link>
            ))}
        </HStack> */}
      <Flex direction="column" alignItems="flex-start" gap="16px" padding="24px">
        <Box>
          <Text color="white" fontWeight={700} fontSize="20px" lineHeight="24px">
            {title}
          </Text>
        </Box>
        {/* <Flex width={"100%"} alignItems="center" gap="16px">
            <Link href={`/perfil/${author?.url}`}>
              <Image
                boxSize="48px"
                src={authorImage}
                objectFit="cover"
                borderRadius="100%"
                alt="User's profile image"
              />
            </Link>
            <Flex direction="column" alignItems="flex-start" gap="4px">
              <Link href={`/perfil/${author?.url}`}>
                <Text
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="20px"
                  color="white"
                >
                  {author?.name}
                </Text>
              </Link>
              <Text
                fontWeight="400"
                fontSize="12px"
                lineHeight="16px"
                color="white"
              >
                {updatedAt} • {readingTime} min read
              </Text>
            </Flex>
          </Flex> */}
      </Flex>
    </Flex>
  );
}
